var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidpage"},[_c('span',{staticClass:"iconfont close-icon",on:{"click":_vm.goLogin}},[_vm._v("")]),_c('img',{attrs:{"src":require("@/assets/img/forbid-icon.png"),"alt":""}}),_c('h1',[_vm._v("您的账号使用受限")]),_c('p',[_vm._v("如有疑问,请联系客服")]),_c('div',{staticClass:"button",on:{"click":_vm.goLogin}},[_vm._v("退出")])])
}
var staticRenderFns = []

export { render, staticRenderFns }